export function offlineIntervals(events) {
    const intervals = [];
    let open = null;
    const sorted = (Array.isArray(events) ? events : [])
        .map((event) => ({
            status: event.new_status,
            time: new Date(event.timestamp).getTime(),
        }))
        .filter((event) => Number.isFinite(event.time))
        .sort((left, right) => left.time - right.time);

    sorted.forEach((event) => {
        if (event.status === "OFFLINE") {
            open = event.time;
        }
        if (event.status === "ONLINE" && open != null) {
            intervals.push([open, event.time]);
            open = null;
        }
    });
    if (open != null) {
        intervals.push([open, Number.POSITIVE_INFINITY]);
    }
    return intervals;
}

export function segmentCrossesOffline(start, end, intervals) {
    if (!Number.isFinite(start) || !Number.isFinite(end)) {
        return false;
    }
    const left = Math.min(start, end);
    const right = Math.max(start, end);
    return intervals.some(([offlineStart, offlineEnd]) => offlineStart < right && offlineEnd > left);
}

export function gapSegment(events) {
    const intervals = offlineIntervals(events);
    if (intervals.length === 0) {
        return undefined;
    }
    return {
        borderColor(context) {
            const start = context?.p0?.parsed?.x;
            const end = context?.p1?.parsed?.x;
            if (segmentCrossesOffline(start, end, intervals)) {
                return "rgba(0,0,0,0)";
            }
            return undefined;
        },
    };
}
